import Editor from '@monaco-editor/react';

interface PropsShape {
    value: any;
    onChange: (code: any) => void;
    language: 'javascript' | 'scss';
}

const CodeEditor = (props: PropsShape) => {
    // Options for the editor
    const editorOptions = {
        minimap: {
            enabled: false, // Set this to false to remove the minimap
        },
    };

    return (
        <Editor
            value={props.value}
            height="40vh"
            language={props.language}
            theme="light"
            options={editorOptions}
            onChange={(evn: any) => props.onChange(evn)}
        />
    );
};

export default CodeEditor;
